import { get, post } from './common'

type ApiBaseResult<T> = ApiTypes.ApiBaseResult<T>
type ApiBasePageResult<T> = ApiTypes.ApiBasePageResult<T>

export namespace user {
  export function getWxQrCode() {
    return get<ApiBaseResult<ServerData.WxQrCodeData>>('/auth/register_qr', {})
  }

  export function checkWxQrCodeStatus(sceneId: string) {
    return get<ApiBaseResult<ServerData.WxLoginStatusData>>('/auth/register_qr/check', { sceneId })
  }

  export function getUserInfo() {
    return get<ApiBaseResult<ServerData.UserData>>('/user/info', {})
  }

  export function saveUserInfo(data: PostData.UserInfoModel) {
    return post<ApiBaseResult<null>>('/user/save', {}, { ...data })
  }

  export function loginByWxGzh(code: string) {
    return get<ApiBaseResult<ServerData.UserData>>('/auth/code_login', { code })
  }

  export function logout() {
    return get<ApiBaseResult<ServerData.UserData>>('/user/logout', {})
  }

  // 获取课件列表
  export function getCoursewareList(data: PostData.SearchModel) {
    return post<ApiBasePageResult<ServerData.CourseData>>(
      '/courseware/search_courseware',
      {},
      { ...data }
    )
  }

  // 获取系列课 - 子课件列表
  export function getTrainingChildList(data: PostData.SearchCourseModel) {
    return post<ApiBaseResult<ServerData.CourseData[]>>(
      '/courseware/search_course',
      {},
      { ...data }
    )
  }

  // 获取已购买系列课
  export function getTrainingPro() {
    return post<ApiBaseResult<ServerData.TrainingProData[]>>('/courseware/course_list', {})
  }

  // 刷新用户信息
  export function refreshUserInfo() {
    return get<ApiBaseResult<null>>('/user/refresh', {})
  }
}
